export default __webpack_public_path__ + "assets/16c3e71fe8c380b9a8f43fed59fa934f.svg";